var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
/* eslint-disable camelcase */
import * as React from 'react';
import { SearchableOptionsInTextField } from './searchable_option_in_text_field';
import { Stack, Text } from '@doordash/design-language';
import { useDebounce } from 'use-debounce';
import { BACKEND_SEARCH_EMAIL_MIN_LENGTH, INPUT_DEBOUNCE_DELAY, } from '../../../constants/ui';
import { searchMembers } from '../../members_slice';
import { getEmailSelectorOptions } from './add_members_to_group_modal';
import { getLastStringFromInputToSearch, getUniqueSeparatedStringsFromTextField, } from '../utils';
import ButtonGroupModalFooter from './button_group_modal_footer';
import { validateTextField } from './validate_emails_utils';
import { useAddTeamMembersToGroupByEmailMutation } from '../useAddTeamMembersToGroupByEmailMutation';
import BulkAddToMemberStrings from './BulkAddToMemberStrings';
import TestIds from './TestIds';
import track from '../../../utils/track';
import { GroupsMembersEvents } from '../../../constants/events';
var strings = BulkAddToMemberStrings.collectAndAddEmails;
var MAX_INPUT_EMAILS = 100;
export var CollectEmailsForm = function (_a) {
    var setTitle = _a.setTitle, group = _a.group, dispatch = _a.dispatch, onClose = _a.onClose, onAddComplete = _a.onAddComplete;
    var textFieldId = 'email-list-text-field';
    var _b = __read(React.useState(''), 2), textFieldValue = _b[0], setTextFieldValue = _b[1];
    var _c = __read(React.useState(''), 2), errorMessage = _c[0], setErrorMessage = _c[1];
    var _d = __read(React.useState([]), 2), emailOptions = _d[0], setEmailOptions = _d[1];
    var _e = __read(React.useState(false), 2), isLoading = _e[0], setIsLoading = _e[1];
    var _f = __read(useDebounce(textFieldValue, INPUT_DEBOUNCE_DELAY), 2), debouncedTextFieldValue = _f[0], isPending = _f[1].isPending;
    var addTeamMembersToGroupByEmail = useAddTeamMembersToGroupByEmailMutation().addTeamMembersToGroupByEmail;
    React.useEffect(function () {
        if (setTitle) {
            setTitle(strings.title());
        }
    }, [setTitle]);
    React.useEffect(function () {
        var searchText = getLastStringFromInputToSearch(debouncedTextFieldValue);
        if (!searchText || searchText.length < BACKEND_SEARCH_EMAIL_MIN_LENGTH) {
            setEmailOptions([]);
            return;
        }
        dispatch(searchMembers({
            teamAccountId: group.teamAccountId,
            pageNumber: '1',
            queryString: searchText,
        }))
            .unwrap()
            .then(function (teamMembers) {
            var emailsOptionsFromTeamMembers = getEmailSelectorOptions(teamMembers);
            // do not show emails that already exist in the text field
            var emailsAlreadySelected = getUniqueSeparatedStringsFromTextField(debouncedTextFieldValue);
            var selectableEmails = emailsOptionsFromTeamMembers.filter(function (member) { return !emailsAlreadySelected.includes(member.email); });
            setEmailOptions(selectableEmails);
        });
    }, [debouncedTextFieldValue, group.teamAccountId, dispatch]);
    var handleEmailOptionSelected = function (option) {
        // force set here to remove UI delay in closing options display
        setEmailOptions([]);
        var searchText = getLastStringFromInputToSearch(debouncedTextFieldValue);
        var newTextFieldValue = textFieldValue.substring(0, textFieldValue.lastIndexOf(searchText)) +
            option.email +
            ', ';
        setTextFieldValue(newTextFieldValue);
    };
    var onAddClick = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _a, isValid, error, emails;
        return __generator(this, function (_b) {
            setIsLoading(true);
            _a = validateTextField(textFieldValue, MAX_INPUT_EMAILS), isValid = _a.isValid, error = _a.error;
            if (!isValid) {
                setIsLoading(false);
                setErrorMessage(error);
                return [2 /*return*/];
            }
            // process add team members to group
            setErrorMessage('');
            emails = getUniqueSeparatedStringsFromTextField(textFieldValue);
            addTeamMembersToGroupByEmail(group.id, emails, {
                onCompleted: function (response) {
                    setIsLoading(false);
                    track(GroupsMembersEvents.ADD_MODAL_SUBMIT_EMAILS, {
                        group_id: group.id,
                        group_name: group.name,
                        email_count: emails.length,
                    });
                    onAddComplete(response === null || response === void 0 ? void 0 : response.addTeamMembersToGroupByEmail);
                },
            });
            return [2 /*return*/];
        });
    }); };
    return (React.createElement(React.Fragment, null,
        React.createElement(Text, { styles: Text.Styles.Caption1 }, strings.bodyText(MAX_INPUT_EMAILS)),
        React.createElement(Stack, null),
        React.createElement(SearchableOptionsInTextField, { label: textFieldId, name: textFieldId, placeholder: strings.placeholderEmails(), isLabelHidden: true, textFieldValue: textFieldValue, options: emailOptions, isLoading: isPending(), onSelectOption: handleEmailOptionSelected, setTextFieldValue: setTextFieldValue }),
        errorMessage && (React.createElement(Text, { "data-testid": TestIds.EMAILS_TEXT_FIELD_ERROR, styles: Text.Styles.FieldMediumInput, color: Text.Colors.TextError }, errorMessage)),
        React.createElement(ButtonGroupModalFooter, { secondary: { action: onClose, text: strings.button.secondaryText() }, primary: {
                action: onAddClick,
                text: strings.button.primaryText(),
                loading: isLoading,
            } })));
};
